<template>
    <div>
        <draggable
            v-model="props.data.items"
            handle=".handle"
            item-key="unique_id"
            :animation="150"
        >
            <template #item="{ element: item }">
                <draggable-accordion
                    class="mb-2"
                    :unique_id="item.unique_id"
                    :edit="item.edit"
                    @remove="removeItem"
                    @toggle="toggleItem(item)"
                >
                    <template #title>{{ item.question || 'Item' }}</template>
                    <template #content>
                        <div class="grid lg:grid-cols-2 gap-6 gap-y-4">
                            <div class="col-span-2">
                                <label
                                    class="flex justify-between items-center mb-1.5 text-sm">
                                    Title
                                </label>

                                <input
                                    type="text"
                                    v-model="item.question"
                                    class="block w-full text-sm rounded border-gray-300 focus:border-gray-400 focus:ring-0"/>
                            </div>
                            <div class="col-span-2">
                                <label
                                    class="flex justify-between items-center mb-1.5 text-sm">
                                    Description
                                </label>

                                <text-editor
                                    :text="item.answer"
                                    @input="(newValue) => { item.answer = newValue }"
                                />
                            </div>
                        </div>
                    </template>
                </draggable-accordion>
            </template>
        </draggable>

        <btn type="secondary" size="small" @click="addItem">Add item</btn>

        <div class="flex justify-between items-center mt-4">
            <toggle
                name="first_item_open"
                @update:model-value="props.data.first_item_open = $event"
                :model-value="props.data.first_item_open ?? false"
            />
            <span class="flex flex-col flex-grow">
                <span class="text-sm font-medium">First item open by default</span>
            </span>
        </div>
    </div>
</template>

<script setup>
import draggable from 'vuedraggable';
import {uniqueId} from '../../resources-builder/helpers';

const props = defineProps({
    data: Object,
    unique_id: String,
});

props.data.items = props.data?.items ?? [];

// Assign unique IDs to existing items that don't have one
props.data.items.forEach(item => {
    if (!item.unique_id) {
        item.unique_id = uniqueId();
    }
});

// Ensure only one item is open at initialization
let foundFirstOpen = false;
props.data.items.forEach(item => {
    if (item.edit) {
        if (foundFirstOpen) {
            item.edit = false;
        } else {
            foundFirstOpen = true;
        }
    }
});

const toggleItem = (element) => {
    const isOpening = !element.edit;
    if (isOpening) {
        props.data.items.forEach(item => {
            if (item.unique_id !== element.unique_id) {
                item.edit = false;
            }
        });
    }
    element.edit = !element.edit;
};

const addItem = () => {
    props.data.items.forEach(item => {
        item.edit = false;
    });

    props.data.items.push({
        unique_id: uniqueId(),
        edit: true,
        question: '',
        answer: '',
    });
};

const removeItem = (uniqueId) => {
    const index = props.data.items.findIndex(item => item.unique_id === uniqueId);
    if (index !== -1) {
        props.data.items.splice(index, 1);
    }
};
</script>
